import styled from "styled-components";

const PillWrapper = styled.span`
  position: relative;
  display: inline-block;
  color: ${(p) => p.textcolor || "#ffffff"};
  padding: 0 0.4rem;
  left: 2px;
  z-index: 1;
  transform: ${(p) => (p.rotatetext ? `rotate(${p.angle})` : "none")};

  font-style: normal;
  &::before {
    content: "";
    position: absolute;
    inset: 0;
    background: ${(p) => p.bg || "var(--my-color5)"};
    border-radius: 6px;
    transform: ${(p) => (p.rotatetext ? "none" : `rotate(${p.angle})`)};
    z-index: -1;
  }
`;

const HighlightPill = ({
  children,
  angle = "-2deg",
  bg = "var(--my-color4)",
  textColor = "#ffffff",
  rotateText = false,
}) => {
  return (
    <PillWrapper
      angle={angle}
      bg={bg}
      textcolor={textColor}
      rotatetext={rotateText ? 1 : 0}
    >
      {children}
    </PillWrapper>
  );
};

export default HighlightPill;
